import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal, Button, DeprecatedIcon, Text, Navigation, Cell } from '@vinted/web-ui';
import { DOMAIN_SELECTED_COOKIE, DOMAIN_SELECTED_COOKIE_EXPIRATION_DATE } from 'constants/domain_selected_cookie';
import { saveCookie } from 'libs/utils/cookies';
import { navigateToPage } from 'libs/utils/window';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const DomainSelectModal = _ref => {
  let {
    domainLinks
  } = _ref;
  const {
    0: show,
    1: setShow
  } = useState(true);

  function openCountryLink(link) {
    navigateToPage(link);
  }

  function handleCloseModal() {
    saveCookie(DOMAIN_SELECTED_COOKIE, 'true', DOMAIN_SELECTED_COOKIE_EXPIRATION_DATE);
    setShow(false);
  }

  function renderCountryCell(countryLink, index) {
    const iconName = DeprecatedIcon.buildIconName('flags', countryLink.code);
    return /*#__PURE__*/_jsx(Cell, {
      onClick: () => openCountryLink(countryLink.link),
      clickable: true,
      prefix: iconName && /*#__PURE__*/_jsx(DeprecatedIcon, {
        name: iconName
      }),
      title: /*#__PURE__*/_jsx(Text, {
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "native_country_names.".concat(countryLink.code)
        }),
        type: Text.Type.Title
      })
    }, index);
  }

  if (!domainLinks.length) return null;
  return /*#__PURE__*/_jsx(Modal, {
    show: show,
    hasScrollableContent: true,
    testId: "domain-select-modal",
    children: /*#__PURE__*/_jsxs("div", {
      className: "u-ui-padding-regular u-fill-width",
      children: [/*#__PURE__*/_jsx(Navigation, {
        theme: "transparent",
        right: /*#__PURE__*/_jsx(Button, {
          testId: "domain-select-modal-close-button",
          styling: Button.Styling.Flat,
          onClick: handleCloseModal,
          deprecatedIconName: "x",
          inline: true
        })
      }), /*#__PURE__*/_jsx(Cell, {
        children: /*#__PURE__*/_jsx(Text, {
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "domain_selection.title"
          }),
          type: Text.Type.Heading,
          as: "h2"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "u-fill-height u-overflow-auto",
        children: domainLinks.map(renderCountryCell)
      })]
    })
  });
};

export default DomainSelectModal;